import React, { Fragment } from 'react';

import { useSelector } from 'react-redux';
import { IFrame } from '@klp/iframe';

import { Main } from '@klp/layout';
import { useTranslation } from 'react-i18next';

import {
    EconomyKeyFiguresAccess,
    PowerBiEconomyKeyFiguresURL,
} from '../config';

import { kommentarerAccess } from '@klp/kommentarer/config';
import { KommentarerView } from '@klp/kommentarer';
import { makeStyles } from '@material-ui/core/styles';
import { contextSelectors } from '@klp/contextSelector';
import { useCurrentUser } from '@klp/auth';

const useStyles = makeStyles(() => ({
    iframe: {
        paddingTop: '50px',
    },
}));

export default function EconomyKeyFiguresView() {
    const { t } = useTranslation();
    const classes = useStyles();
    const { currentUser } = useCurrentUser();
    const { selectedContext } = useSelector(contextSelectors);

    const filteredKeyFiguresHandler = () => {
        let filteredLink = PowerBiEconomyKeyFiguresURL();

        // Determine what filter should be applied to the key figures url.
        if (selectedContext?.nummer !== undefined) {
            filteredLink += `&filter=dim_bygg_avdeling/bygg_avdeling_id%20eq%20%27${selectedContext.nummer}%27`;

            return filteredLink;
        }

        return filteredLink;
    };

    return (
        <>
            <Main>
                <Main.Breadcrumbs>
                    <Main.Crumb
                        id="economykeyfigures"
                        label={t('breadcrumbs.keyFigures.economy')}
                    />
                </Main.Breadcrumbs>
                {EconomyKeyFiguresAccess(currentUser) &&
                    (!selectedContext ? (
                        /* Add a better error message / component here */
                        <div
                            style={{
                                display: 'flex',
                                width: '100%',
                                height: '100%',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <p>{t('keyfigures.noContextSelected')}</p>
                        </div>
                    ) : (
                        <IFrame
                            src={filteredKeyFiguresHandler()}
                            fullScreen={true}
                            noSandbox={true}
                            className={classes.iframe}
                        />
                    ))}
            </Main>
            {kommentarerAccess() && <KommentarerView disableDragger={true} />}
        </>
    );
}
